// import { ApplicationStackParamList } from "cc-web-client/@types/navigation";
import ImportGames from '../Screens/ImportGames';
import SelectAvatar from '../Screens/SelectAvatar';
import Dashboard from '../Screens/Dashboard';
import Games from '../Screens/Games';
import Puzzles from '../Screens/Puzzles';
import Goals from '../Screens/Goals';
import Profile from '../Screens/Settings';
import ComingSoon from '../Screens/ComingSoon';
import Onboardingprogress from '../Screens/Onboardingprogress';
import ChessAnalysis from '@/Screens/ChessAnalysis';
import Login from '@/Screens/Login';
import WaitList from '@/Screens/WaitList';
import Assessments from '@/Screens/Assessments';
import AssessmentReport from '@/Screens/AssessmentReport';
import RewardsComponent from '@/Screens/Rewards';
import OnboardingWalkthrough from '@/Screens/OnboardingWalkthrough';
import OTBGames from '@/Screens/OTBGames';
import SaveOTBGames from '@/Screens/SaveOTBGames';
import ReportAnIssue from '@/Screens/ReportAnIssue/ReportAnIssue';
import Visualisation from '@/Screens/Visualisation';
import Books from '@/Screens/Books';
import Reports from '@/Screens/Reports';
import TableauReport from '@/Screens/TableauReport';
import Study from '@/Screens/Study';
import StudyGameList from '@/Screens/StudyGameList';
import PlayChess from '@/Screens/PlayChess';
import Subscription from '@/Screens/Subscription';
import PaymentStatus from '@/Screens/Payments';
import CCHome from '@/Screens/CCHome';
import LMS from '@/Screens/LMS';
import ReportBug from '@/Screens/ReportBug';
import TournamentsScreen from '@/Screens/CCTournaments';
import RequestAccess from '@/Screens/RequestAccess';
import Classroom from '@/Screens/Classroom';
import TicketListScreen from '@/Screens/SupportTicket';
import Inbox from '@/Screens/Inbox';
import RenewalScreen from '@/Screens/Renewal';
import RenewalPaymentScreen from '@/Screens/Renewal/components/RenewalPaymentScreen';
import SuccessPage from '@/Screens/Renewal/components/SuccessPage';
import OpeningPerformanceReportScreen from '@/Screens/OpeningPerformanceReportScreen';
import RenewalPuzzleChallenge from '@/Screens/RenewalPuzzleChallenge';
import CSOCHealthDashboard from '@/Screens/CSOCHealthDashboard';
import ManualSubstituteAssignment from '@/Screens/ManualSubstituteAssignment';
import SubstituteFlowDashboard from '@/Screens/SubstituteFlowDashboard';

export interface Screen {
  id: number;
  Name: string;
  component: React.ComponentType<any>;
  props?: object;
  withAuth?: boolean;
  menuOptions?: Object;
  hideMenu?: boolean;
}

export const UnauthenticatedScreens: Screen[] = [
  {id: 11, Name: 'login', component: Login},
  {id: 12, Name: 'waitlist', component: WaitList},
  {id: 13, Name: 'home', component: CCHome},
  {id: 14, Name: 'evaluateLogin', component: Login},
  {id: 15, Name: 'cc-admin-login', component: Login},
];

export const OnboardingScreenStack: Screen[] = [
  {id: 3, Name: 'importgames', component: ImportGames},
  {id: 4, Name: 'selectavatar', component: SelectAvatar},
  {id: 6, Name: 'onboardingprogress', component: Onboardingprogress},
];

export const evaluateLoginScreenStack: Screen[] = [
  {id: 15, Name: 'resources', component: Books},
];

// Key is the screen name and value is the web url name
export const ScreenStack: Screen[] = [
  // {id: 1, Name: 'home', component: Home},

  {id: 1, Name: 'dashboard', component: Dashboard, menuOptions: {icon: 'home'}},
  {
    id: 2,
    Name: 'CCTournaments',
    component: PlayChess,
    menuOptions: {label: 'Tournaments', icon: 'trophy-variant'},
  },
  {
    id: 3,
    Name: 'playChess',
    component: PlayChess,
    menuOptions: {label: 'Play', icon: 'gamepad-variant'},
  },
  {
    id: 4,
    Name: 'games',
    component: Games,
    menuOptions: {
      icon: 'folder-open',
      label: 'Game Review',
      preAnalysisDisabled: false,
    },
  },
  {
    id: 5,
    Name: 'assessmentReport',
    component: AssessmentReport,
    menuOptions: {
      icon: 'book-open',
      label: 'Assessment',
      preAnalysisDisabled: false,
    },
  },
  {
    id: 6,
    Name: 'resources',
    component: Books,
    menuOptions: {
      label: 'School Of Chess',
      icon: 'book',
    },
  },
  {
    id: 7,
    Name: 'positions',
    component: Puzzles,
    menuOptions: {
      label: 'Positions Trainer',
      icon: 'puzzle',
      preAnalysisDisabled: false,
    },
  },
  {
    id: 8,
    Name: 'VisualisationTrainer',
    component: Visualisation,
    // props: {feature: 'Coming soon', cover_img: 2},
    menuOptions: {icon: 'account-tie-voice', label: 'Visualization Trainer'},
  },
  // {
  //   id: 20,
  //   Name: 'SquareTrainer',
  //   component: Visualisation,
  //   // props: {feature: 'Coming soon', cover_img: 2},
  //   menuOptions: {icon: 'account-tie-voice', label: 'Square Trainer'},
  // },
  {
    id: 9,
    Name: 'reports',
    component: Reports,
    props: {
      feature: 'Reports 📈 to help you understand your Childs progress 🦸 !',
      cover_img: 2,
    },
    menuOptions: {
      icon: 'file-chart',
      preAnalysisDisabled: false,
      // isStaff: true,
    },

    // menuOptions: {icon: 'file-chart', preAnalysisDisabled: false},
  },
  {
    id: 10,
    Name: 'tableau-reports',
    component: TableauReport,
    props: {
      feature: 'Reports 📈 to help understand data!',
      cover_img: 2,
    },
    menuOptions: {
      icon: 'file-chart',
      preAnalysisDisabled: false,
      isStaff: true,
    },

    // menuOptions: {icon: 'file-chart', preAnalysisDisabled: false},
  },
  {
    id: 11,
    Name: 'otb',
    component: OTBGames,
    props: {
      feature:
        'Save snaps 🤳 of your OTB game notations 🗒️ through CircleChess WhatsApp companion!',
      cover_img: 1,
    },
    menuOptions: {label: 'OTB Games', icon: 'eye', hide: false},
  },

  {
    id: 12,
    Name: 'Rules-and-Rewards',
    component: RewardsComponent,
    props: {feature: 'Coming soon', cover_img: 2},
    menuOptions: {
      label: 'Rules and Rewards',
      icon: 'gift',
      preAnalysisDisabled: false,
    },
  },
  {
    id: 13,
    Name: 'courses',
    component: LMS,
    menuOptions: {
      label: 'Courses',
      icon: 'book-open',
      // isStaff: true,
    },
  },

  {
    id: 14,
    Name: 'assessments',
    component: Assessments,
    menuOptions: {icon: 'folder-open', hide: true, preAnalysisDisabled: true},
  },
  // {
  //   id: 7,
  //   Name: 'goals',
  //   component: Goals,
  //   menuOptions: {label: 'Rules', icon: 'flag', hide: true},
  // },

  {id: 15, Name: 'Settings', component: Profile, menuOptions: {hide: true}},
  {
    id: 16,
    Name: 'chessAnalysis',
    component: ChessAnalysis,
    menuOptions: {hide: true, preAnalysisDisabled: false},
  },
  {
    id: 17,
    Name: 'SaveOTBGames',
    component: SaveOTBGames,
    menuOptions: {hide: true},
  },
  {
    id: 18,
    Name: 'ReportAnIssue',
    component: ReportAnIssue,
    menuOptions: {hide: true},
  },

  {
    id: 19,
    Name: 'studyDetails',
    component: Study,
    menuOptions: {hide: true},
  },
  {
    id: 20,
    Name: 'studyList',
    component: StudyGameList,
    menuOptions: {label: 'Workbook', icon: 'school'},
  },
  {
    id: 21,
    Name: 'subscription',
    component: Subscription,
    menuOptions: {label: 'Subscription', icon: 'diamond'},
  },
  {
    id: 22,
    Name: 'payment',
    component: PaymentStatus,
    menuOptions: {label: 'payment', hide: true},
  },
  {
    id: 23,
    Name: 'Report-a-bug',
    component: ReportBug,
    menuOptions: {
      hide: true,
      // label: 'Raise a Ticket',
      // icon: 'alert',
    },
  },

  {
    id: 24,
    Name: 'RequestAccess',
    component: RequestAccess,
    menuOptions: {
      label: 'requestAccess',
      hide: true,
    },
  },
  {
    id: 25,
    Name: 'SupportTicket',
    component: TicketListScreen,
    menuOptions: {hide: true},
  },
  {
    id: 26,
    Name: 'Inbox',
    component: Inbox,
    menuOptions: {hide: true},
  },
  {
    id: 27, //change id if required, I have previously done support as 22
    Name: 'Classroom',
    component: Classroom,
    props: {
      feature: 'Caissa classroom for circle chess students🦸!',
    },
    //menuOptions: {icon: 'book-open', hide: true, isStaff: true},
    menuOptions: {label: 'classroom', hide: true},
  },
  {id: 28, Name: 'importgames', component: ImportGames, menuOptions:{hide: true}},
  {
    id: 29,
    Name: 'Renewal',
    component: RenewalScreen,
    menuOptions: {hide: true},
  },
  {
    id: 30,
    Name: 'RenewalPayment',
    component: RenewalPaymentScreen,
    menuOptions: {hide: true},
  },
  {
    id: 32,
    Name: 'CsocNewPayment',
    component: RenewalScreen,
    menuOptions: {hide: true},
  },
  {
    id: 31,
    Name: 'SuccessPage',
    component: SuccessPage,
    menuOptions: {hide: true},
  },
  {
    id: 33,
    Name: 'OpeningPerformanceReport',
    component: OpeningPerformanceReportScreen,
    menuOptions: {
      label: 'Opening Report',
      icon: 'book-open-variant',
      hide: !__DEV__,
    },
  },
  {
    id: 34,
    Name: 'RenewalPuzzleChallenge',
    component: RenewalPuzzleChallenge,
    menuOptions: {
      label: 'Renewal Challenge',
      icon: 'chess-pawn',
      hide: true,
    },
  },
  {
    id: 35,
    Name: 'csocHealthDashboard',
    component: CSOCHealthDashboard,
    menuOptions: {
      label: 'CSOC Health',
      icon: 'medical-bag',
      isStaff: true,
    },
  },
  {
    id: 36,
    Name: 'manualSubstituteAssignment',
    component: ManualSubstituteAssignment,
    menuOptions: {
      label: 'Substitute Coach',
      icon: 'account-switch',
      isStaff: true,
    },
  },
  {
    id: 37,
    Name: 'substituteFlowDashboard',
    component: SubstituteFlowDashboard,
    menuOptions: {
      label: 'Substitute Flow',
      icon: 'account-clock',
      isStaff: true,
    },
  },
];

export const OnboardingWalkthroughStack = [
  {
    id: 16,
    Name: 'OnboardingWalkthrough',
    component: OnboardingWalkthrough,
    menuOptions: {
      // hide: true,
      headerShown: false,
      swipeEnabled: false,
      gestureEnabled: false,
    },
  },
];

export const ScreenName = {
  Home: 'Home',
  Login: 'Login',
  Waitlist: 'Waitlist',
  Assessments: 'Assessments',
  AssessmentReport: 'AssessmentReport',
  ImportGames: 'Importgames',
  Reports: 'Reports',
  SelectAvatar: 'Selectavatar',
  Dashboard: 'Dashboard',
  Onboardingprogress: 'Onboardingprogress',
  ChessAnalysis: 'ChessAnalysis',
  Puzzles: 'Positions',
  Games: 'Games',
  Books: 'Resources',
  Goals: 'Goals',
  ComingSoon: 'ComingSoon',
  Rewards: 'Rules-and-Rewards',
  Settings: 'Settings',
  Otb: 'Otb',
  OnboardingWalkthrough: 'OnboardingWalkthrough',
  SaveOTBGames: 'SaveOTBGames',
  ReportAnIssue: 'ReportAnIssue',
  Visualisation: 'VisualisationTrainer',
  StudyList: 'StudyList',
  StudyDetails: 'StudyDetails',
  PlayChess: 'PlayChess',
  Subscription: 'Subscription',
  PaymentStatus: 'PaymentStatus',
  ReportBug: 'Report-a-bug',
  SupportTicket: 'SupportTicket',
  Inbox: 'Inbox',
  Tournaments: 'CCTournaments',
  RequestAccess: 'RequestAccess',
  Courses: 'Courses',
  Classroom: 'Classroom',
  Renewal: 'Renewal',
  RenewalPayment: 'RenewalPayment',
  CsocNewPayment: 'CsocNewPayment',
  OpeningPerformanceReport: 'OpeningPerformanceReport',
  RenewalPuzzleChallenge: 'RenewalPuzzleChallenge',
  CSOCHealthDashboard: 'CsocHealthDashboard',
  ManualSubstituteAssignment: 'ManualSubstituteAssignment',
  SubstituteFlowDashboard: 'SubstituteFlowDashboard',
};
